import { SSOProvider } from '@app/models/auth/sso-provider.enum';

// Mirrors the backend's CalendarAccessStatus: whether the calendar can be used right now, and if not, whether
// connecting again would fix it.
export enum CalendarAccessStatus {
    NOT_LINKED = 'NOT_LINKED',
    CONNECTED = 'CONNECTED',
    ACCESS_LOST = 'ACCESS_LOST',
    UNAVAILABLE = 'UNAVAILABLE'
}

export interface CalendarConnectionStatus {
    provider: SSOProvider;
    access: CalendarAccessStatus;
    connected: boolean;
    email?: string;
}
